/** Delay in ms before showing tagger avatars tooltip on hover */
export const POPOVER_HOVER_DELAY = 350;

/** Maximum avatars to show before overflow counter */
export const MAX_VISIBLE_AVATARS = 4;
